<ul class="nav nav-pills flex-column mb-3" id="sidebar-pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="firmas-pendiendes-tab" data-bs-toggle="pill" data-bs-target="#firmas-pendiendes" type="button" role="tab" aria-controls="firmas-pendiendes" aria-selected="true">
            <div id="signature-container" class="me-2">
                <i class="fas fa-solid fa-signature fa-fw fa-lg text-primary"></i>
            </div>
            <!-- Documentos Pendientes -->
            Documentos
        </button>
    </li>

    <!--PARA EL FUTURO
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="firmados-tab" data-bs-toggle="pill" data-bs-target="#firmados" type="button" role="tab" aria-controls="firmados" aria-selected="false">
            <div id="signature-container" class="me-2">
                <i class="fas fa-solid fa-file-signature fa-fw fa-lg text-primary"></i>
            </div>
            Documentos Firmados
        </button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="rechazados-tab" data-bs-toggle="pill" data-bs-target="#rechazados" type="button" role="tab" aria-controls="rechazados" aria-selected="false">
            <div id="signature-container" class="me-2">
                <i class="fas fa-solid fa-ban fa-fw fa-lg text-primary"></i>
            </div>
            Documentos Rechazados
        </button>
    </li> -->
</ul>
